import { useState, type ReactNode } from "react";
import { ProductContext, type Product } from "./product-context";

type ProductProviderProps = {
  children: ReactNode;
};

export const ProductProvider = ({ children }: ProductProviderProps) => {
  const [product, setProduct] = useState<Product | undefined>(undefined);

  return (
    <ProductContext.Provider value={{ product, setProduct }}>
      {children}
    </ProductContext.Provider>
  );
};
